// The demo chat characters (offline profiles and their selfies). Its own module, not part of
// staticImages.jsx, because helpers.jsx uses it and helpers.jsx is in every page's first load
// (AuthContext imports it): importing staticImages.jsx from there shipped every landing page's
// image list to every page (plan step W2, 2026-10-07). staticImages.jsx re-exports it.

const girl11 = '/assets/profiles/girl_1_pic_1.webp'
const girl12 = '/assets/profiles/girl_1_pic_2.webp'
const girl13 = '/assets/profiles/girl_1_pic_3.webp'
const girl21 = '/assets/profiles/girl_2_pic_1.webp'
const girl22 = '/assets/profiles/girl_2_pic_2.webp'
const girl23 = '/assets/profiles/girl_2_pic_4.webp'
const girl31 = '/assets/profiles/girl_3_pic_1.webp'
const girl32 = '/assets/profiles/girl_3_pic_2.webp'
const girl33 = '/assets/profiles/girl_3_pic_3.webp'
const girl41 = '/assets/profiles/girl_4_pic_1.webp'
const girl42 = '/assets/profiles/girl_4_pic_3.webp'
const girl43 = '/assets/profiles/girl_4_pic_4.webp'
const girl51 = '/assets/profiles/girl_5_pic_1.webp'
const girl52 = '/assets/profiles/girl_5_pic_2.webp'
const girl53 = '/assets/profiles/girl_5_pic_3.webp'
const girl61 = '/assets/profiles/girl_6_pic_1.webp'
const girl62 = '/assets/profiles/girl_6_pic_2.webp'
const girl63 = '/assets/profiles/girl_6_pic_3.webp'
const girl71 = '/assets/profiles/girl_7_pic_1.webp'
const girl72 = '/assets/profiles/girl_7_pic_2.webp'
const girl73 = '/assets/profiles/girl_7_pic_3.webp'
const girl81 = '/assets/profiles/girl_8_pic_1.webp'
const girl82 = '/assets/profiles/girl_8_pic_2.webp'
const girl83 = '/assets/profiles/girl_8_pic_3.webp'

const selfie1 = '/assets/profiles/1.webp'
const selfie2 = '/assets/profiles/2.webp'
const selfie3 = '/assets/profiles/3.webp'
const selfie4 = '/assets/profiles/4.webp'
const selfie5 = '/assets/profiles/5.webp'
const selfie6 = '/assets/profiles/6.webp'
const selfie7 = '/assets/profiles/7.webp'
const selfie8 = '/assets/profiles/8.webp'

export const staticProfiles = [
  {
    id: '1',
    imageUrl: [girl11, girl12, girl13],
    name: 'Michelle',
    occupation: 'Unemployed',
    location: 'Detroit',
    personality: 'Take me out to an expensive restaurant',
    uid: '57qlmsb4JlTEpZmuooqlTgj1rLy2',
    age: 22,
    sexuality: 'Straight',
    gender: 'Woman',
    offlineSelfie: selfie1,
  },
  {
    id: '2',
    imageUrl: [girl31, girl32, girl33],
    name: 'Fatima',
    occupation: 'Designer',
    location: 'New York',
    personality: 'I am actually quite skinny haha',
    uid: '57qlmsb4JlTEpZmuooqlTgj1rLy2',
    age: 24,
    sexuality: 'Straight',
    gender: 'Woman',
    offlineSelfie: selfie3,
  },
  {
    id: '3',
    imageUrl: [girl41, girl42, girl43],
    name: 'Ju Won',
    occupation: 'Singer',
    location: 'Gangnam',
    personality: 'I love k-pop, looking for my Jimin 💗',
    uid: '57qlmsb4JlTEpZmuooqlTgj1rLy2',
    age: 26,
    sexuality: 'Lesbian',
    gender: 'Woman',
    offlineSelfie: selfie4,
  },
  {
    id: '4',
    imageUrl: [girl71, girl72, girl73],
    name: 'Ella',
    occupation: 'Gamer',
    location: 'London',
    personality: 'Gamer girl at heart <3',
    uid: '57qlmsb4JlTEpZmuooqlTgj1rLy2',
    age: 19,
    sexuality: 'Asexual',
    gender: 'Non-binary',
    offlineSelfie: selfie7,
  },
  {
    id: '5',
    imageUrl: [girl81, girl82, girl83],
    name: 'Amira',
    occupation: 'Vlogger',
    location: 'Amsterdam',
    personality: 'Come see the world with meee',
    uid: '57qlmsb4JlTEpZmuooqlTgj1rLy2',
    age: 25,
    sexuality: 'Lesbian',
    gender: 'Woman',
    offlineSelfie: selfie8,
  },
  {
    id: '6',
    imageUrl: [girl21, girl22, girl23],
    name: 'Sarah',
    occupation: 'Student',
    location: 'Toronto',
    personality: 'Guess my favourite dance? (Floss)',
    uid: '57qlmsb4JlTEpZmuooqlTgj1rLy2',
    age: 21,
    sexuality: 'Straight',
    gender: 'Woman',
    offlineSelfie: selfie2,
  },
  {
    id: '7',
    imageUrl: [girl61, girl62, girl63],
    name: 'Jennifer',
    occupation: 'Flight Attendant',
    location: 'Spain',
    personality: 'I love to travel around the world 🌎',
    uid: '57qlmsb4JlTEpZmuooqlTgj1rLy2',
    age: 21,
    sexuality: 'Straight',
    gender: 'Woman',
    offlineSelfie: selfie6,
  },
  {
    id: '8',
    imageUrl: [girl51, girl52, girl53],
    name: 'Meg',
    occupation: 'Singer',
    location: 'Texas',
    personality: 'Lol No, I am not from Family Guy 🍒',
    uid: '57qlmsb4JlTEpZmuooqlTgj1rLy2',
    age: 20,
    sexuality: 'Straight',
    gender: 'Woman',
    offlineSelfie: selfie5,
  },
]
